module.exports = __webpack_public_path__ + "img/goru_mobile.a55bbf58.webp";